import React from 'react';
import PropTypes from 'prop-types';
import { GameHero, Lottie, Pill } from '../games_components/GameUI';

const CONFETTI_MS = 2000;

class PurchaseCelebration extends React.Component {
  state = { confettiComplete: false };

  componentDidMount() {
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduceMotion) {
      this.setState({ confettiComplete: true });
      return;
    }
    this.timer = setTimeout(() => this.setState({ confettiComplete: true }), CONFETTI_MS);
  }

  componentWillUnmount() {
    clearTimeout(this.timer);
  }

  renderConfetti() {
    return (
      <div className="gpConfetti">
        <span className="gpConfetti__emoji" aria-hidden="true">🎉</span>
        <h1 className="gpConfetti__title">You got it!</h1>
        <Lottie src={this.props.confettiLottie} className="gpConfetti__lottie" />
      </div>
    );
  }

  renderLink(href, label, emoji, variant) {
    const classes = variant === 'soft' ? 'gpButton gpButton--soft gpSpaceTop' : 'gpButton gpButton--primary';
    return (
      <a className={classes} href={href}>
        <span className="gpButton__row">
          <span className="gpButton__emoji" aria-hidden="true">{emoji}</span>
          <span>{label}</span>
        </span>
      </a>
    );
  }

  renderComplete() {
    const benefits = this.props.benefits || [];
    return (
      <div className="gpSplit gpSplit--complete">
        <div className="gpSplit__hero">
          <GameHero
            centered
            emoji={this.props.emoji}
            image={this.props.image}
            kicker={this.props.kicker}
            title={this.props.headline}
            subtitle={this.props.message}
          >
            {!!this.props.badgeNumber && (
              <div className="gpScoreBadge">
                <span className="gpScoreBadge__number">{this.props.badgeNumber}</span>
                <span className="gpScoreBadge__label">{this.props.badgeLabel}</span>
              </div>
            )}
          </GameHero>
        </div>

        <div className="gpSplit__main">
          {benefits.length > 0 && (
            <div className="gpCard gpEnter gpReflect" style={{ animationDelay: '70ms' }}>
              <div className="gpCardLabel">
                <span className="gpCardLabel__emoji" aria-hidden="true">✨</span>
                <h2 className="gpCardLabel__text">What's included</h2>
              </div>
              <div className="gpReflect__topics">
                {benefits.map((benefit) => (
                  <Pill key={benefit} emoji="✓" text={benefit} />
                ))}
              </div>
            </div>
          )}

          {this.renderLink(this.props.primaryHref, this.props.primaryLabel, '🤝', 'primary')}
          {this.renderLink(this.props.secondaryHref, this.props.secondaryLabel, '🏠', 'soft')}
        </div>
      </div>
    );
  }

  render() {
    return (
      <div className="gpPage">
        <div className="gpPage__inner">
          {this.state.confettiComplete ? this.renderComplete() : this.renderConfetti()}
        </div>
      </div>
    );
  }
}

PurchaseCelebration.propTypes = {
  kicker: PropTypes.string,
  headline: PropTypes.string,
  message: PropTypes.string,
  emoji: PropTypes.string,
  image: PropTypes.string,
  badgeNumber: PropTypes.string,
  badgeLabel: PropTypes.string,
  benefits: PropTypes.arrayOf(PropTypes.string),
  confettiLottie: PropTypes.string,
  primaryHref: PropTypes.string,
  primaryLabel: PropTypes.string,
  secondaryHref: PropTypes.string,
  secondaryLabel: PropTypes.string,
};

PurchaseCelebration.defaultProps = {
  benefits: [],
  primaryLabel: 'Start finding Connects',
  secondaryLabel: 'Back to dashboard',
};

export default PurchaseCelebration;
